export const setTypeItems = (items) => {
    return {
        type: 'REPORT_SET_TYPES',
        payload: {
            items,
        },
    };
};
